import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = ({ className }) => {
  const { i18n } = useTranslation();

  const setEnglish = useCallback(() => {
    i18n.changeLanguage("en");
  }, [i18n]);

  const setSpanish = useCallback(() => {
    i18n.changeLanguage("es");
  }, [i18n]);

  const setChinese = useCallback(() => {
    i18n.changeLanguage("zh-hant");
  }, [i18n]);

  return (
    <div className={className}>
      <button onClick={setEnglish}>English</button>
      <button onClick={setSpanish}>Spanish</button>
      <button onClick={setChinese}>Chinese</button>
    </div>
  );
};

export default LanguageSwitcher;
